module.exports = __webpack_public_path__ + "img/mail.ecb71f40.svg";